import React from 'react';

/**
 * Chip / Badge — semantic status chip (height 22, radius 11, font 11/500).
 *
 * Variants:
 *   active    — green tint
 *   warning   — amber tint
 *   critical  — red tint
 *   info      — blue tint
 *   neutral   — grey tint
 */
const VARIANTS = {
  active:   { bg: '#e3f0d8', fg: '#2f5a2c' },
  warning:  { bg: '#fbe9c7', fg: '#8a5a1a' },
  critical: { bg: '#fadcdc', fg: '#a4282f' },
  info:     { bg: '#d8e4f0', fg: '#2c4f7a' },
  neutral:  { bg: '#ececea', fg: '#5b5f5b' },
};

export const Chip = ({
  variant = 'neutral',
  children,
  dot = false,
  className = '',
  ...rest
}) => {
  const cfg = VARIANTS[variant] || VARIANTS.neutral;
  return (
    <span
      className={[
        'inline-flex items-center gap-1.5 h-[22px] px-2 rounded-[11px]',
        'text-[11px] font-medium leading-none whitespace-nowrap',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
      style={{ background: cfg.bg, color: cfg.fg }}
      {...rest}
    >
      {dot && (
        <span
          className="w-1.5 h-1.5 rounded-full"
          style={{ background: cfg.fg }}
          aria-hidden="true"
        />
      )}
      {children}
    </span>
  );
};
